import { OrderRejectionReason } from '../../../../../../../services/exports/Constants';

export default {
  statuses: {
    rejected: 'Annullato: {{reason}}',
    fulfilled: 'Questo ordine è stato completato con successo',
  },
  rejection_reasons: {
    [OrderRejectionReason.Automatic]: 'Non accettato',
    [OrderRejectionReason.ClosingSoon]: 'Chiusura imminente',
    [OrderRejectionReason.ItemUnavailable]: 'Articolo non disponibile',
    [OrderRejectionReason.OrderTooBig]: 'Ordine troppo grande',
    [OrderRejectionReason.CustomerMistake]: 'Errore del cliente',
    [OrderRejectionReason.Other]: 'Altro',
    fully_refunded: "L'ordine è stato completamente rimborsato",
  },
};
